import {defineMessages} from 'react-intl';

export default defineMessages({
	alreadyExist: {
		id: 'socialLogin.alreadyExist',
		defaultMessage: 'The customer already exists.',
	},
	error: {
		id: 'socialLogin.error',
		defaultMessage: 'Something went wrong.',
	},
});
